import { useState, useEffect, useCallback } from "react";

// ==================== 初期データ（画像から取得）====================
const INITIAL_LIST = {
  id: "2026-04",
  label: "2026年4月号",
  totalBudget: 300000,
  stocks: [
    { no:1,  code:"9986", name:"蔵王産業",                    yield:3.95, sector:"卸売",        type:"defensive", ratio:2, amount:6000,  dividend:237  },
    { no:2,  code:"3076", name:"あいHD",                      yield:3.99, sector:"卸売",        type:"defensive", ratio:3, amount:9000,  dividend:359  },
    { no:3,  code:"8130", name:"サンゲツ",                    yield:5.04, sector:"卸売",        type:"defensive", ratio:2, amount:6000,  dividend:302  },
    { no:4,  code:"2659", name:"サンエー",                    yield:3.22, sector:"小売",        type:"defensive", ratio:3, amount:9000,  dividend:290  },
    { no:5,  code:"3333", name:"あさひ",                      yield:3.59, sector:"小売",        type:"defensive", ratio:3, amount:9000,  dividend:323  },
    { no:6,  code:"4008", name:"住友精化",                    yield:3.60, sector:"化学",        type:"cyclical",  ratio:2, amount:6000,  dividend:216  },
    { no:7,  code:"4042", name:"東ソー",                      yield:4.28, sector:"化学",        type:"cyclical",  ratio:3, amount:9000,  dividend:385  },
    { no:8,  code:"4097", name:"高圧ガス工業",                yield:3.59, sector:"化学",        type:"cyclical",  ratio:3, amount:9000,  dividend:323  },
    { no:9,  code:"4958", name:"長谷川香料",                  yield:3.47, sector:"化学",        type:"cyclical",  ratio:2, amount:6000,  dividend:208  },
    { no:10, code:"8309", name:"三井住友トラストグループ",    yield:3.32, sector:"銀行",        type:"cyclical",  ratio:3, amount:9000,  dividend:299  },
    { no:11, code:"8725", name:"MS&ADインシュアランスグループHD", yield:3.75, sector:"保険", type:"cyclical",  ratio:3, amount:9000,  dividend:338  },
    { no:12, code:"8584", name:"ジャックス",                  yield:4.84, sector:"その他金融",  type:"cyclical",  ratio:3, amount:9000,  dividend:436  },
    { no:13, code:"6785", name:"鈴木",                        yield:3.45, sector:"電気機器",    type:"cyclical",  ratio:2, amount:6000,  dividend:207  },
    { no:14, code:"7723", name:"愛知時計電機",                yield:3.80, sector:"精密機器",    type:"cyclical",  ratio:3, amount:9000,  dividend:342  },
    { no:15, code:"3231", name:"野村不動産HD",                yield:3.84, sector:"不動産",      type:"cyclical",  ratio:3, amount:9000,  dividend:346  },
    { no:16, code:"3003", name:"ヒューリック",                yield:3.57, sector:"不動産",      type:"cyclical",  ratio:3, amount:9000,  dividend:321  },
    { no:17, code:"2169", name:"CDS",                         yield:4.03, sector:"サービス",    type:"defensive", ratio:3, amount:9000,  dividend:363  },
    { no:18, code:"9757", name:"船井総研ホールディングス",    yield:4.12, sector:"サービス",    type:"defensive", ratio:2, amount:6000,  dividend:247  },
    { no:19, code:"9769", name:"学究社",                      yield:4.32, sector:"サービス",    type:"defensive", ratio:3, amount:9000,  dividend:389  },
    { no:20, code:"4641", name:"アルプス技研",                yield:4.16, sector:"サービス",    type:"defensive", ratio:2, amount:6000,  dividend:250  },
    { no:21, code:"3817", name:"SRAホールディングス",         yield:3.96, sector:"情報・通信",  type:"defensive", ratio:2, amount:6000,  dividend:238  },
    { no:22, code:"3901", name:"マークラインズ",              yield:3.79, sector:"情報・通信",  type:"defensive", ratio:2, amount:6000,  dividend:227  },
    { no:23, code:"4674", name:"クレスコ",                    yield:4.01, sector:"情報・通信",  type:"defensive", ratio:2, amount:6000,  dividend:241  },
    { no:24, code:"4746", name:"東計電算",                    yield:4.08, sector:"情報・通信",  type:"defensive", ratio:2, amount:6000,  dividend:245  },
    { no:25, code:"2003", name:"日東富士製粉",                yield:3.85, sector:"食料品",      type:"defensive", ratio:3, amount:9000,  dividend:347  },
    { no:26, code:"1928", name:"積水ハウス",                  yield:4.07, sector:"建設",        type:"cyclical",  ratio:3, amount:9000,  dividend:366  },
    { no:27, code:"6345", name:"アイチコーポレーション",      yield:4.50, sector:"機械",        type:"cyclical",  ratio:3, amount:9000,  dividend:405  },
    { no:28, code:"9364", name:"上組",                        yield:3.36, sector:"倉庫・運輸関連", type:"defensive", ratio:3, amount:9000, dividend:302 },
    { no:29, code:"9381", name:"エーアイテイー",              yield:4.49, sector:"倉庫・運輸関連", type:"defensive", ratio:3, amount:9000, dividend:404 },
    { no:30, code:"7989", name:"立川ブラインド工業",          yield:4.73, sector:"金属製品",    type:"cyclical",  ratio:3, amount:9000,  dividend:426  },
    { no:31, code:"7820", name:"ニホンフラッシュ",            yield:4.44, sector:"その他製品",  type:"cyclical",  ratio:2, amount:6000,  dividend:266  },
    { no:32, code:"7994", name:"オカムラ",                    yield:4.08, sector:"その他製品",  type:"cyclical",  ratio:3, amount:9000,  dividend:367  },
    { no:33, code:"4540", name:"ツムラ",                      yield:3.75, sector:"医薬品",      type:"defensive", ratio:3, amount:9000,  dividend:338  },
    { no:34, code:"1343", name:"NF・J-REIT ETF",             yield:4.47, sector:"J-REIT市場",  type:"defensive", ratio:13, amount:39000, dividend:1743 },
  ]
};

// ==================== ストレージ ====================
const STORAGE_KEY = "dividend_portfolio_v1";

function loadData() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return { lists: [INITIAL_LIST], holdings: {}, prices: {} };
}

function saveData(data) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch {}
}

// ==================== ユーティリティ ====================
const TYPE_LABEL = { cyclical: "景気敏感", defensive: "ディフェンシブ" };
const TYPE_COLOR = { cyclical: "#f59e0b", defensive: "#10b981" };

function calcShares(targetAmount, pricePerShare) {
  if (!pricePerShare || pricePerShare <= 0) return null;
  return Math.floor(targetAmount / pricePerShare);
}

// ==================== コンポーネント ====================
export default function App() {
  const [data, setData] = useState(loadData);
  const [tab, setTab] = useState("current"); // current | history | import | holdings
  const [selectedListId, setSelectedListId] = useState(data.lists[0]?.id || "");
  const [compareId, setCompareId] = useState("");
  const [importText, setImportText] = useState("");
  const [importError, setImportError] = useState("");
  const [notification, setNotification] = useState("");

  useEffect(() => { saveData(data); }, [data]);

  const notify = (msg) => {
    setNotification(msg);
    setTimeout(() => setNotification(""), 2500);
  };

  const currentList = data.lists.find(l => l.id === selectedListId) || data.lists[0];
  const compareList = compareId ? data.lists.find(l => l.id === compareId) : null;

  // 保有株数の更新
  const updateHolding = useCallback((code, shares) => {
    setData(prev => ({
      ...prev,
      holdings: { ...prev.holdings, [code]: Number(shares) || 0 }
    }));
  }, []);

  // 現在株価の更新
  const updatePrice = useCallback((code, val) => {
    setData(prev => ({
      ...prev,
      prices: { ...prev.prices, [code]: Number(val) || 0 }
    }));
  }, []);

  // 全データをJSONファイルとしてダウンロード（エクスポート）
  const exportAllData = () => {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `dividend-portfolio-${new Date().toISOString().slice(0,10)}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
    notify('✅ エクスポートしました');
  };

  // JSONファイルから全データを復元（インポート）
  const importFromFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const parsed = JSON.parse(ev.target.result);
        if (!parsed.lists || !Array.isArray(parsed.lists)) throw new Error('形式が正しくありません（listsが見つかりません）');
        if (!window.confirm('現在のデータをすべて上書きしてインポートしますか？')) return;
        setData(parsed);
        setSelectedListId(parsed.lists[0]?.id || '');
        notify('✅ データをインポートしました');
        setTab('current');
      } catch (err) {
        alert('読み込みエラー：' + err.message);
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  // リスト追加
  const importList = () => {
    setImportError("");
    try {
      const parsed = JSON.parse(importText);
      if (!parsed.id || !parsed.label || !Array.isArray(parsed.stocks)) throw new Error("フォーマットが正しくありません");
      if (data.lists.find(l => l.id === parsed.id)) throw new Error(`ID「${parsed.id}」は既に存在します`);
      const newData = { ...data, lists: [...data.lists, parsed] };
      setData(newData);
      setSelectedListId(parsed.id);
      setImportText("");
      notify("✅ リストを追加しました");
      setTab("current");
    } catch (e) { setImportError(e.message); }
  };

  // 差分計算
  const getDiff = () => {
    if (!compareList || !currentList) return { added: [], removed: [] };
    const prevCodes = new Set(compareList.stocks.map(s => s.code));
    const currCodes = new Set(currentList.stocks.map(s => s.code));
    return {
      added:   currentList.stocks.filter(s => !prevCodes.has(s.code)),
      removed: compareList.stocks.filter(s => !currCodes.has(s.code)),
    };
  };

  const diff = getDiff();

  // セクター集計
  const sectorSummary = currentList ? Object.entries(
    currentList.stocks.reduce((acc, s) => {
      acc[s.sector] = (acc[s.sector] || 0) + s.amount;
      return acc;
    }, {})
  ).sort((a,b) => b[1]-a[1]) : [];

  const totalDividend = currentList?.stocks.reduce((s, x) => s + x.dividend, 0) || 0;

  return (
    <div style={styles.root}>
      {/* ヘッダー */}
      <header style={styles.header}>
        <div style={styles.headerInner}>
          <div>
            <div style={styles.headerTitle}>📈 高配当株ポートフォリオ</div>
            <div style={styles.headerSub}>学長リスト管理ツール</div>
          </div>
          {currentList && (
            <div style={styles.headerStats}>
              <div style={styles.statBox}>
                <div style={styles.statVal}>¥{(currentList.totalBudget || 0).toLocaleString()}</div>
                <div style={styles.statLabel}>総予算</div>
              </div>
              <div style={styles.statBox}>
                <div style={{...styles.statVal, color:"#10b981"}}>¥{totalDividend.toLocaleString()}</div>
                <div style={styles.statLabel}>年間配当(概算)</div>
              </div>
              <div style={styles.statBox}>
                <div style={{...styles.statVal, color:"#f59e0b"}}>
                  {currentList.stocks.length > 0
                    ? (totalDividend / currentList.totalBudget * 100).toFixed(2)
                    : "0.00"}%
                </div>
                <div style={styles.statLabel}>平均利回り</div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* タブ */}
      <nav style={styles.nav}>
        {[
          { id:"current",  label:"📋 現在のリスト" },
          { id:"holdings", label:"💼 保有・株数管理" },
          { id:"history",  label:"🔄 月次差分比較" },
          { id:"import",   label:"➕ リスト追加" },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={tab===t.id ? styles.tabActive : styles.tab}>
            {t.label}
          </button>
        ))}
      </nav>

      <main style={styles.main}>
        {/* 通知 */}
        {notification && <div style={styles.notif}>{notification}</div>}

        {/* リスト選択 */}
        {(tab==="current"||tab==="history"||tab==="holdings") && (
          <div style={styles.listSelector}>
            <label style={styles.label}>表示するリスト：</label>
            <select value={selectedListId} onChange={e=>setSelectedListId(e.target.value)} style={styles.select}>
              {data.lists.map(l=>(
                <option key={l.id} value={l.id}>{l.label}</option>
              ))}
            </select>
          </div>
        )}

        {/* ===== 現在のリスト ===== */}
        {tab==="current" && currentList && (
          <div>
            <SectorChart summary={sectorSummary} total={currentList.totalBudget} />
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.thead}>
                    <th style={styles.th}>No</th>
                    <th style={styles.th}>コード</th>
                    <th style={styles.th}>銘柄名</th>
                    <th style={styles.th}>配当利回り</th>
                    <th style={styles.th}>セクター</th>
                    <th style={styles.th}>種別</th>
                    <th style={styles.th}>割合</th>
                    <th style={styles.th}>投資額(円)</th>
                    <th style={styles.th}>年間配当(円)</th>
                  </tr>
                </thead>
                <tbody>
                  {currentList.stocks.map((s, i) => (
                    <tr key={s.code} style={i%2===0 ? styles.trEven : styles.trOdd}>
                      <td style={styles.td}>{s.no}</td>
                      <td style={{...styles.td, fontWeight:700, color:"#3b82f6"}}>{s.code}</td>
                      <td style={{...styles.td, fontWeight:600}}>{s.name}</td>
                      <td style={{...styles.td, color:"#10b981", fontWeight:700}}>{s.yield.toFixed(2)}%</td>
                      <td style={styles.td}>{s.sector}</td>
                      <td style={styles.td}>
                        <span style={{...styles.badge, background: TYPE_COLOR[s.type]+"20", color: TYPE_COLOR[s.type], border:`1px solid ${TYPE_COLOR[s.type]}50`}}>
                          {TYPE_LABEL[s.type]}
                        </span>
                      </td>
                      <td style={styles.td}>{s.ratio}%</td>
                      <td style={styles.tdNum}>¥{s.amount.toLocaleString()}</td>
                      <td style={{...styles.tdNum, color:"#10b981"}}>¥{s.dividend.toLocaleString()}</td>
                    </tr>
                  ))}
                  <tr style={{background:"#1e293b", fontWeight:700}}>
                    <td colSpan={6} style={{...styles.td, textAlign:"right", color:"#94a3b8"}}>合計</td>
                    <td style={styles.td}>100%</td>
                    <td style={styles.tdNum}>¥{currentList.totalBudget.toLocaleString()}</td>
                    <td style={{...styles.tdNum, color:"#10b981"}}>¥{totalDividend.toLocaleString()}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ===== 保有・株数管理 ===== */}
        {tab==="holdings" && currentList && (
          <HoldingsTab
            list={currentList}
            holdings={data.holdings}
            updateHolding={updateHolding}
            allLists={data.lists}
            prices={data.prices || {}}
            updatePrice={updatePrice}
          />
        )}

        {/* ===== 差分比較 ===== */}
        {tab==="history" && (
          <div>
            <div style={styles.listSelector}>
              <label style={styles.label}>比較元（前月）：</label>
              <select value={compareId} onChange={e=>setCompareId(e.target.value)} style={styles.select}>
                <option value="">-- 選択してください --</option>
                {data.lists.filter(l=>l.id!==selectedListId).map(l=>(
                  <option key={l.id} value={l.id}>{l.label}</option>
                ))}
              </select>
            </div>
            {compareId && (
              <DiffView diff={diff} currentList={currentList} compareList={compareList} holdings={data.holdings} />
            )}
            {!compareId && (
              <div style={styles.emptyMsg}>比較元のリストを選択してください</div>
            )}
          </div>
        )}

        {/* ===== リスト追加 ===== */}
        {tab==="import" && (
          <ImportTab
            importText={importText}
            setImportText={setImportText}
            importError={importError}
            importList={importList}
            currentList={currentList}
            exportAllData={exportAllData}
            importFromFile={importFromFile}
          />
        )}
      </main>
    </div>
  );
}

// ==================== セクターチャート ====================
const SECTOR_COLORS = [
  "#3b82f6","#10b981","#f59e0b","#ef4444","#8b5cf6",
  "#06b6d4","#f97316","#84cc16","#ec4899","#14b8a6",
  "#a78bfa","#fb923c","#34d399","#60a5fa","#fbbf24",
];

function SectorChart({ summary, total }) {
  const cx = 110, cy = 110, r = 92, inner = 54;

  let cumAngle = -Math.PI / 2;
  const slices = summary.map(([sector, amt], i) => {
    const pct = amt / total;
    const angle = pct * 2 * Math.PI;
    const startAngle = cumAngle;
    const endAngle = cumAngle + angle;
    cumAngle = endAngle;
    const x1  = cx + r     * Math.cos(startAngle);
    const y1  = cy + r     * Math.sin(startAngle);
    const x2  = cx + r     * Math.cos(endAngle);
    const y2  = cy + r     * Math.sin(endAngle);
    const ix1 = cx + inner * Math.cos(startAngle);
    const iy1 = cy + inner * Math.sin(startAngle);
    const ix2 = cx + inner * Math.cos(endAngle);
    const iy2 = cy + inner * Math.sin(endAngle);
    const largeArc = angle > Math.PI ? 1 : 0;
    const path = `M ${ix1} ${iy1} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} L ${ix2} ${iy2} A ${inner} ${inner} 0 ${largeArc} 0 ${ix1} ${iy1} Z`;
    return { sector, amt, pct, path, color: SECTOR_COLORS[i % SECTOR_COLORS.length] };
  });

  return (
    <div style={styles.chartCard}>
      <div style={styles.cardTitle}>📊 セクター別配分</div>
      <div style={{display:"flex", gap:20, alignItems:"center", flexWrap:"wrap"}}>
        <svg width={220} height={220} viewBox="0 0 220 220" style={{flexShrink:0}}>
          {slices.map(s => (
            <path key={s.sector} d={s.path} fill={s.color} opacity={0.88} />
          ))}
          <text x={cx} y={cy - 7} textAnchor="middle" fill="#e2e8f0" fontSize={13} fontWeight="700">合計</text>
          <text x={cx} y={cy + 12} textAnchor="middle" fill="#94a3b8" fontSize={11}>{total.toLocaleString()}円</text>
        </svg>
        <div style={{flex:1, display:"flex", flexDirection:"column", gap:7, minWidth:160}}>
          {slices.map(s => (
            <div key={s.sector} style={{display:"flex", alignItems:"center", gap:8}}>
              <div style={{width:11, height:11, borderRadius:3, background:s.color, flexShrink:0}} />
              <span style={{fontSize:12, color:"#94a3b8", flex:1}}>{s.sector}</span>
              <span style={{fontSize:12, fontWeight:700, color:"#e2e8f0"}}>{(s.pct*100).toFixed(1)}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ==================== 保有ポートフォリオ円グラフ ====================
function HoldingsChart({ allLists, holdings, prices }) {
  // 全リストから銘柄を重複なく収集
  const allStocksMap = {};
  allLists.forEach(l => {
    l.stocks.forEach(s => { if (!allStocksMap[s.code]) allStocksMap[s.code] = s; });
  });

  // セクター別に保有額（株価×保有株数）を集計
  const sectorMap = {};
  let total = 0;
  Object.values(allStocksMap).forEach(s => {
    const held = holdings[s.code] || 0;
    const price = prices[s.code] || 0;
    if (held > 0 && price > 0) {
      const val = held * price;
      sectorMap[s.sector] = (sectorMap[s.sector] || 0) + val;
      total += val;
    }
  });

  const summary = Object.entries(sectorMap).sort((a, b) => b[1] - a[1]);

  if (total === 0) {
    return (
      <div style={styles.chartCard}>
        <div style={styles.cardTitle}>🥧 保有ポートフォリオ（セクター別）</div>
        <div style={{color:"#64748b", fontSize:13, lineHeight:1.7}}>
          株価と保有株数を入力すると、あなたのポートフォリオの分散状況が円グラフで表示されます。
        </div>
      </div>
    );
  }

  const cx = 110, cy = 110, r = 92, inner = 54;
  let cumAngle = -Math.PI / 2;
  const slices = summary.map(([sector, amt], i) => {
    const pct = amt / total;
    const angle = pct * 2 * Math.PI;
    const startAngle = cumAngle;
    const endAngle = cumAngle + angle;
    cumAngle = endAngle;
    const x1  = cx + r     * Math.cos(startAngle);
    const y1  = cy + r     * Math.sin(startAngle);
    const x2  = cx + r     * Math.cos(endAngle);
    const y2  = cy + r     * Math.sin(endAngle);
    const ix1 = cx + inner * Math.cos(startAngle);
    const iy1 = cy + inner * Math.sin(startAngle);
    const ix2 = cx + inner * Math.cos(endAngle);
    const iy2 = cy + inner * Math.sin(endAngle);
    const largeArc = angle > Math.PI ? 1 : 0;
    const path = `M ${ix1} ${iy1} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} L ${ix2} ${iy2} A ${inner} ${inner} 0 ${largeArc} 0 ${ix1} ${iy1} Z`;
    return { sector, amt, pct, path, color: SECTOR_COLORS[i % SECTOR_COLORS.length] };
  });

  return (
    <div style={styles.chartCard}>
      <div style={styles.cardTitle}>🥧 保有ポートフォリオ（セクター別）</div>
      <div style={{display:"flex", gap:20, alignItems:"center", flexWrap:"wrap"}}>
        <svg width={220} height={220} viewBox="0 0 220 220" style={{flexShrink:0}}>
          {slices.map(s => (
            <path key={s.sector} d={s.path} fill={s.color} opacity={0.88} />
          ))}
          <text x={cx} y={cy - 7} textAnchor="middle" fill="#e2e8f0" fontSize={13} fontWeight="700">保有総額</text>
          <text x={cx} y={cy + 12} textAnchor="middle" fill="#94a3b8" fontSize={11}>¥{total.toLocaleString()}</text>
        </svg>
        <div style={{flex:1, display:"flex", flexDirection:"column", gap:7, minWidth:160}}>
          {slices.map(s => (
            <div key={s.sector} style={{display:"flex", alignItems:"center", gap:8}}>
              <div style={{width:11, height:11, borderRadius:3, background:s.color, flexShrink:0}} />
              <span style={{fontSize:12, color:"#94a3b8", flex:1}}>{s.sector}</span>
              <span style={{fontSize:12, fontWeight:700, color:"#e2e8f0"}}>{(s.pct*100).toFixed(1)}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ==================== 保有・株数管理タブ ====================
function HoldingsTab({ list, holdings, updateHolding, allLists, prices, updatePrice }) {
  const [budget, setBudget] = useState(list.totalBudget || 300000);
  const [priceMode, setPriceMode] = useState("auto"); // auto | manual

  return (
    <div>
      <HoldingsChart allLists={allLists} holdings={holdings} prices={prices} />
      <div style={styles.chartCard}>
        <div style={styles.cardTitle}>💡 使い方</div>
        <div style={{color:"#94a3b8", fontSize:14, lineHeight:1.7}}>
          1. 各銘柄の <b style={{color:"#e2e8f0"}}>現在株価</b> を入力してください<br/>
          2. 学長リストの<b style={{color:"#e2e8f0"}}>投資割合</b>を維持するために<b style={{color:"#10b981"}}>必要株数</b>が自動計算されます<br/>
          3. <b style={{color:"#e2e8f0"}}>既に保有している株数</b>を入力すると、<b style={{color:"#f59e0b"}}>追加で必要な株数</b>が表示されます
        </div>
        <div style={{marginTop:12, display:"flex", alignItems:"center", gap:12, flexWrap:"wrap"}}>
          <label style={styles.label}>総予算：</label>
          <input
            type="number"
            value={budget}
            onChange={e=>setBudget(Number(e.target.value)||0)}
            style={{...styles.input, width:140}}
          />
          <span style={{color:"#94a3b8", fontSize:13}}>円</span>
        </div>
      </div>

      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.thead}>
              <th style={styles.th}>コード</th>
              <th style={styles.th}>銘柄名</th>
              <th style={styles.th}>割合</th>
              <th style={styles.th}>目標投資額</th>
              <th style={{...styles.th, background:"#1e3a5f"}}>現在株価(円)</th>
              <th style={{...styles.th, background:"#1a3a2a"}}>必要株数</th>
              <th style={{...styles.th, background:"#2a2a1a"}}>保有株数</th>
              <th style={{...styles.th, background:"#3a1a1a"}}>追加必要株数</th>
              <th style={{...styles.th, background:"#1a2a3a"}}>追加投資額(円)</th>
            </tr>
          </thead>
          <tbody>
            {list.stocks.map((s, i) => {
              const targetAmt = Math.round(budget * s.ratio / 100);
              const price = prices[s.code] || 0;
              const needed = price > 0 ? Math.floor(targetAmt / price) : null;
              const held = holdings[s.code] || 0;
              const additional = needed !== null ? Math.max(0, needed - held) : null;
              const addCost = additional !== null && price > 0 ? additional * price : null;

              return (
                <tr key={s.code} style={i%2===0 ? styles.trEven : styles.trOdd}>
                  <td style={{...styles.td, color:"#3b82f6", fontWeight:700}}>{s.code}</td>
                  <td style={{...styles.td, fontWeight:600, fontSize:13}}>{s.name}</td>
                  <td style={styles.td}>{s.ratio}%</td>
                  <td style={styles.tdNum}>¥{targetAmt.toLocaleString()}</td>
                  <td style={{...styles.td, background:"#1e3a5f20"}}>
                    <input
                      type="number"
                      value={prices[s.code]||""}
                      onChange={e=>updatePrice(s.code, e.target.value)}
                      placeholder="株価"
                      style={{...styles.inputSmall, width:90}}
                    />
                  </td>
                  <td style={{...styles.td, background:"#1a3a2a20", textAlign:"right"}}>
                    {needed !== null
                      ? <span style={{color:"#10b981", fontWeight:700}}>{needed}株</span>
                      : <span style={{color:"#4b5563"}}>-</span>}
                  </td>
                  <td style={{...styles.td, background:"#2a2a1a20"}}>
                    <input
                      type="number"
                      value={held||""}
                      onChange={e=>updateHolding(s.code, e.target.value)}
                      placeholder="0"
                      style={{...styles.inputSmall, width:70}}
                    />
                  </td>
                  <td style={{...styles.td, background:"#3a1a1a20", textAlign:"right"}}>
                    {additional !== null
                      ? additional > 0
                        ? <span style={{color:"#ef4444", fontWeight:700}}>+{additional}株</span>
                        : <span style={{color:"#6b7280"}}>充足</span>
                      : <span style={{color:"#4b5563"}}>-</span>}
                  </td>
                  <td style={{...styles.td, background:"#1a2a3a20", textAlign:"right"}}>
                    {addCost !== null
                      ? addCost > 0
                        ? <span style={{color:"#f59e0b", fontWeight:700}}>¥{addCost.toLocaleString()}</span>
                        : <span style={{color:"#6b7280"}}>-</span>
                      : <span style={{color:"#4b5563"}}>-</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{color:"#64748b", fontSize:12, marginTop:8, padding:"0 4px"}}>
        ※ 株価は最新の株価を手動で入力してください。必要株数 = 目標投資額 ÷ 株価（端数切り捨て）
      </div>
    </div>
  );
}

// ==================== 差分比較ビュー ====================
function DiffView({ diff, currentList, compareList, holdings }) {
  return (
    <div>
      <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:20}}>
        <div style={{...styles.chartCard, borderColor:"#10b98130"}}>
          <div style={{...styles.cardTitle, color:"#10b981"}}>✅ 新規追加銘柄（{diff.added.length}件）</div>
          {diff.added.length === 0
            ? <div style={{color:"#6b7280", fontSize:13}}>変更なし</div>
            : diff.added.map(s=>(
              <div key={s.code} style={styles.diffRow}>
                <span style={{color:"#3b82f6", fontWeight:700, fontSize:13}}>{s.code}</span>
                <span style={{color:"#e2e8f0", fontSize:13, marginLeft:8}}>{s.name}</span>
                <span style={{color:"#10b981", fontSize:12, marginLeft:"auto"}}>{s.yield.toFixed(2)}%</span>
              </div>
            ))
          }
        </div>
        <div style={{...styles.chartCard, borderColor:"#ef444430"}}>
          <div style={{...styles.cardTitle, color:"#ef4444"}}>❌ 除外銘柄（{diff.removed.length}件）</div>
          {diff.removed.length === 0
            ? <div style={{color:"#6b7280", fontSize:13}}>変更なし</div>
            : diff.removed.map(s=>(
              <div key={s.code} style={styles.diffRow}>
                <span style={{color:"#3b82f6", fontWeight:700, fontSize:13}}>{s.code}</span>
                <span style={{color:"#94a3b8", fontSize:13, marginLeft:8, textDecoration:"line-through"}}>{s.name}</span>
              </div>
            ))
          }
        </div>
      </div>

      {diff.added.length > 0 && (
        <div style={styles.chartCard}>
          <div style={styles.cardTitle}>📐 新規銘柄の必要株数（参考）</div>
          <div style={{color:"#94a3b8", fontSize:13, marginBottom:12}}>
            新しく追加された銘柄について、学長リストの割合で投資するために必要な株数の目安です。<br/>
            正確な計算は「保有・株数管理」タブで株価を入力してください。
          </div>
          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>コード</th>
                  <th style={styles.th}>銘柄名</th>
                  <th style={styles.th}>セクター</th>
                  <th style={styles.th}>割合</th>
                  <th style={styles.th}>目標投資額</th>
                  <th style={styles.th}>利回り</th>
                </tr>
              </thead>
              <tbody>
                {diff.added.map((s,i)=>(
                  <tr key={s.code} style={i%2===0?styles.trEven:styles.trOdd}>
                    <td style={{...styles.td, color:"#3b82f6", fontWeight:700}}>{s.code}</td>
                    <td style={{...styles.td, fontWeight:600}}>{s.name}</td>
                    <td style={styles.td}>{s.sector}</td>
                    <td style={styles.td}>{s.ratio}%</td>
                    <td style={styles.tdNum}>¥{s.amount.toLocaleString()}</td>
                    <td style={{...styles.td, color:"#10b981", fontWeight:700}}>{s.yield.toFixed(2)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

// ==================== インポートタブ ====================
function ImportTab({ importText, setImportText, importError, importList, currentList, exportAllData, importFromFile }) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setImportText(ev.target.result);
    reader.readAsText(file);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setImportText(ev.target.result);
    reader.readAsText(file);
    e.target.value = '';
  };

  const template = JSON.stringify({
    id: "2026-05",
    label: "2026年5月号",
    totalBudget: 300000,
    stocks: [
      { no:1, code:"1234", name:"サンプル株式", yield:4.00, sector:"卸売", type:"defensive", ratio:3, amount:9000, dividend:360 }
    ]
  }, null, 2);

  return (
    <div>
      {/* バックアップ・同期セクション */}
      <div style={{...styles.chartCard, borderColor:"#3b82f640"}}>
        <div style={styles.cardTitle}>🔄 データのバックアップ・同期</div>
        <div style={{color:"#94a3b8", fontSize:13, lineHeight:1.8, marginBottom:16}}>
          MacとiPhoneで同じデータを使うには、以下の手順で手動同期してください。<br/>
          <b style={{color:"#e2e8f0"}}>① エクスポート</b>でJSONファイルをダウンロード →
          <b style={{color:"#e2e8f0"}}>② 別の端末でインポート</b>して読み込む
        </div>
        <div style={{display:"flex", gap:12, flexWrap:"wrap"}}>
          {/* エクスポートボタン */}
          <button onClick={exportAllData} style={{...styles.btn, background:"#10b981"}}>
            📤 エクスポート（全データをダウンロード）
          </button>
          {/* インポートボタン */}
          <label style={{...styles.btn, background:"#f59e0b", cursor:"pointer", display:"inline-block"}}>
            📥 インポート（ファイルから復元）
            <input type="file" accept=".json,application/json" onChange={importFromFile}
              style={{display:"none"}} />
          </label>
        </div>
        <div style={{color:"#64748b", fontSize:12, marginTop:12}}>
          ⚠️ インポートすると現在のデータがすべて上書きされます。事前にエクスポートしてバックアップしてください。
        </div>
      </div>

      <div style={styles.chartCard}>
        <div style={styles.cardTitle}>📝 新しいリストをJSONで追加</div>
        <div style={{color:"#94a3b8", fontSize:13, lineHeight:1.8, marginBottom:12}}>
          毎月学長が発表するリストを以下のJSON形式で入力してください。<br/>
          <b style={{color:"#f59e0b"}}>type</b>: <code style={styles.code}>"cyclical"</code>（景気敏感）または <code style={styles.code}>"defensive"</code>（ディフェンシブ）<br/>
          <b style={{color:"#f59e0b"}}>ratio</b>: 投資割合（%）<br/>
          <b style={{color:"#f59e0b"}}>amount</b>: 投資額（円）<br/>
          <b style={{color:"#f59e0b"}}>dividend</b>: 年間配当（円）
        </div>
        <details style={{marginBottom:12}}>
          <summary style={{cursor:"pointer", color:"#3b82f6", fontSize:13}}>JSONテンプレートを表示</summary>
          <pre style={styles.pre}>{template}</pre>
        </details>

        {/* ファイル選択ボタン */}
        <div style={{marginBottom:10}}>
          <label style={{...styles.btn, background:"#334155", cursor:"pointer", display:"inline-block", fontSize:13, padding:"8px 16px"}}>
            📁 JSONファイルを選択
            <input type="file" accept=".json,application/json" onChange={handleFileSelect} style={{display:"none"}} />
          </label>
          <span style={{color:"#64748b", fontSize:12, marginLeft:10}}>または下のエリアにドラッグ＆ドロップ</span>
        </div>

        {/* ドラッグ＆ドロップ対応テキストエリア */}
        <div
          onDragOver={e=>{e.preventDefault(); setIsDragging(true);}}
          onDragLeave={()=>setIsDragging(false)}
          onDrop={handleDrop}
          style={{
            border: isDragging ? "2px dashed #3b82f6" : "2px dashed #334155",
            borderRadius: 8,
            background: isDragging ? "#1e3a5f" : "transparent",
            transition: "all 0.2s",
          }}
        >
          <textarea
            value={importText}
            onChange={e=>setImportText(e.target.value)}
            placeholder="JSONファイルをここにドロップ、またはテキストを貼り付け..."
            style={{...styles.textarea, border:"none", background:"transparent"}}
          />
        </div>
        {importError && <div style={styles.error}>⚠️ {importError}</div>}
        <button onClick={importList} style={styles.btn}>追加する</button>
      </div>

      <div style={styles.chartCard}>
        <div style={styles.cardTitle}>💾 現在保存中のリスト</div>
        <div style={{color:"#94a3b8", fontSize:13, marginBottom:8}}>
          ※ データはこのブラウザのlocalStorageに保存されています<br/>
          別の端末に移すには、上の「エクスポート」ボタンをご利用ください
        </div>
        <pre style={{...styles.pre, maxHeight:200, overflowY:"auto", fontSize:11}}>
          {JSON.stringify(currentList, null, 2)}
        </pre>
      </div>
    </div>
  );
}

// ==================== スタイル ====================
const styles = {
  root: {
    minHeight: "100vh",
    background: "#0f172a",
    color: "#e2e8f0",
    fontFamily: "'Hiragino Sans', 'Yu Gothic', sans-serif",
  },
  header: {
    background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
    borderBottom: "1px solid #1e3a5f",
    padding: "16px 20px",
  },
  headerInner: {
    display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12,
  },
  headerTitle: {
    fontSize: 20, fontWeight: 800, color: "#e2e8f0", letterSpacing: -0.5,
  },
  headerSub: {
    fontSize: 12, color: "#64748b", marginTop: 2,
  },
  headerStats: {
    display: "flex", gap: 16, flexWrap: "wrap",
  },
  statBox: {
    textAlign: "center", background: "#1e293b", borderRadius: 8, padding: "8px 16px",
    border: "1px solid #334155",
  },
  statVal: {
    fontSize: 16, fontWeight: 800, color: "#e2e8f0",
  },
  statLabel: {
    fontSize: 10, color: "#64748b", marginTop: 2,
  },
  nav: {
    display: "flex", gap: 4, padding: "12px 20px", background: "#0f172a",
    borderBottom: "1px solid #1e293b", flexWrap: "wrap",
  },
  tab: {
    padding: "8px 14px", borderRadius: 6, border: "1px solid #334155",
    background: "transparent", color: "#94a3b8", cursor: "pointer", fontSize: 13,
  },
  tabActive: {
    padding: "8px 14px", borderRadius: 6, border: "1px solid #3b82f6",
    background: "#1e3a5f", color: "#60a5fa", cursor: "pointer", fontSize: 13, fontWeight: 700,
  },
  main: {
    maxWidth: 1200, margin: "0 auto", padding: "20px 16px",
  },
  notif: {
    background: "#065f46", border: "1px solid #10b981", borderRadius: 8,
    padding: "10px 16px", marginBottom: 16, color: "#6ee7b7", fontSize: 14,
  },
  listSelector: {
    display: "flex", alignItems: "center", gap: 10, marginBottom: 16, flexWrap: "wrap",
  },
  label: {
    color: "#94a3b8", fontSize: 13,
  },
  select: {
    background: "#1e293b", border: "1px solid #334155", borderRadius: 6,
    color: "#e2e8f0", padding: "6px 12px", fontSize: 13,
  },
  input: {
    background: "#1e293b", border: "1px solid #334155", borderRadius: 6,
    color: "#e2e8f0", padding: "6px 10px", fontSize: 14,
  },
  inputSmall: {
    background: "#0f172a", border: "1px solid #334155", borderRadius: 4,
    color: "#e2e8f0", padding: "4px 8px", fontSize: 12, textAlign: "right",
  },
  chartCard: {
    background: "#1e293b", border: "1px solid #334155", borderRadius: 12,
    padding: 16, marginBottom: 16,
  },
  cardTitle: {
    fontSize: 14, fontWeight: 700, color: "#e2e8f0", marginBottom: 12,
  },
  sectorChip: {
    display: "flex", alignItems: "center", gap: 8, background: "#0f172a",
    borderRadius: 6, padding: "6px 10px", minWidth: 200, flex: 1,
  },
  sectorBar: {
    width: 60, height: 6, background: "#334155", borderRadius: 3, overflow: "hidden",
  },
  sectorFill: {
    height: "100%", background: "linear-gradient(90deg, #3b82f6, #10b981)",
    borderRadius: 3, transition: "width 0.3s",
  },
  tableWrap: {
    overflowX: "auto", borderRadius: 10, border: "1px solid #334155",
  },
  table: {
    width: "100%", borderCollapse: "collapse", fontSize: 13,
  },
  thead: {
    background: "#1e293b",
  },
  th: {
    padding: "10px 12px", color: "#94a3b8", fontWeight: 600,
    borderBottom: "1px solid #334155", whiteSpace: "nowrap", textAlign: "center",
  },
  td: {
    padding: "8px 12px", borderBottom: "1px solid #1e293b", verticalAlign: "middle",
  },
  tdNum: {
    padding: "8px 12px", borderBottom: "1px solid #1e293b", textAlign: "right",
    fontFamily: "monospace", verticalAlign: "middle",
  },
  trEven: { background: "#0f172a" },
  trOdd:  { background: "#131f30" },
  badge: {
    display: "inline-block", padding: "2px 8px", borderRadius: 20,
    fontSize: 11, fontWeight: 600, whiteSpace: "nowrap",
  },
  diffRow: {
    display: "flex", alignItems: "center", padding: "6px 0",
    borderBottom: "1px solid #1e293b",
  },
  textarea: {
    width: "100%", minHeight: 200, background: "#0f172a", border: "1px solid #334155",
    borderRadius: 8, color: "#e2e8f0", padding: 12, fontSize: 12,
    fontFamily: "monospace", resize: "vertical", boxSizing: "border-box",
  },
  pre: {
    background: "#0f172a", border: "1px solid #334155", borderRadius: 8,
    padding: 12, fontSize: 12, color: "#94a3b8", overflow: "auto",
    fontFamily: "monospace", lineHeight: 1.6, marginTop: 8,
  },
  code: {
    background: "#0f172a", padding: "1px 6px", borderRadius: 4, fontSize: 12,
    color: "#f59e0b",
  },
  btn: {
    marginTop: 12, padding: "10px 24px", background: "#3b82f6",
    border: "none", borderRadius: 8, color: "#fff", fontWeight: 700,
    cursor: "pointer", fontSize: 14,
  },
  error: {
    marginTop: 8, color: "#ef4444", fontSize: 13,
    background: "#3a1a1a", padding: "8px 12px", borderRadius: 6,
  },
  emptyMsg: {
    color: "#64748b", fontSize: 14, textAlign: "center", padding: 40,
    background: "#1e293b", borderRadius: 12,
  },
};
